export default "__VITE_ASSET__dd5b6470__"